"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mapChecks_exports = {};
__export(mapChecks_exports, {
  reset: () => reset,
  view: () => view
});
module.exports = __toCommonJS(mapChecks_exports);
var import_util = require("@cartographerio/util");
var import_check = require("../check/index.js");
function view(project) {
  const description = `View maps in project ${project.name}`;
  switch (project.mapVisibility) {
    case "Project":
      switch (project.projectVisibility) {
        case "Private":
          return import_check.check.named(
            description,
            import_check.check.and(
              import_check.check.workspaceReadOnlyAccess(project.workspaceId),
              import_check.check.projectMember(project.id, project.workspaceId, project.teamIds)
            )
          );
        case "Workspace":
          return import_check.check.named(
            description,
            import_check.check.and(import_check.check.workspaceReadOnlyAccess(project.workspaceId), import_check.check.workspaceActive(project.workspaceId))
          );
        default:
          return (0, import_util.checkExhausted)(project.projectVisibility);
      }
    case "Public":
      return import_check.check.named(description, import_check.check.workspaceReadOnlyAccess(project.workspaceId));
    default:
      return (0, import_util.checkExhausted)(project.mapVisibility);
  }
}
function reset() {
  return import_check.check.named(`Reset map data`, import_check.check.superuser);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  reset,
  view
});
//# sourceMappingURL=mapChecks.js.map
